import { ExamStage } from '@const/exam'
import { observable, action } from 'mobx'

export interface IExamStore {
  examStage: number
}

class ExamStore implements IExamStore {
  @observable public examStage = ExamStage.info

  @action
  public setExamStage = (stage: number) => {
    this.examStage = stage
  }
}

export default new ExamStore()
